/*
 * @Description: inputItemList
 * @Author: hongyao.lm
 * @Date: 2018-11-13 11:32:42
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-01-20 09:55:19
 */

import React, { Fragment } from 'react';
import { toJS } from 'mobx';
import dayjs from 'dayjs';
import { Flex, List, InputItem, TextareaItem, Modal } from 'antd-mobile';
import { Radio, AddressPicker, FilePicker, Picker, DatePicker, ImagePicker } from 'widget';
import Util from 'utils';
import Config from 'config/Config';
import './index.less';
import { get } from 'lodash';
import cx from 'classnames';
import { observer, inject } from 'mobx-react';
import { Language_List } from 'config/language/context';
import { countryList, getDomainCodeByAreaCode } from 'utils/constants';

const alert = Modal.alert;
// // 代码分割
// const AddressPicker = React.lazy(() => import('widget/AddressPicker'));
// const FilePicker = React.lazy(() => import('widget/FilePicker'));

/**
 * 使用方法：1.定义一个array，如:
 * [{
       label: '',
       id: '',
       type: '',     //输入框类型(日期表单  调试时传递给date的value值必须是date对象),默认不传是普通的input类型，【area是区域，select是选择, ~
                     // date是日期, textarea是多行输入, fullWord是多行显示, skip是跳转动作或只单纯获取点击钩子, radio是单选框, upload是上传文件】
       inputType: 当是input输入框时，限定输入框的值的类型
       placeholder: '',
       editable: false //是否可以编辑
       target: Url,  // 当type为skip时生效
       cleanSpace: false, // 是否清除输出字符串空格
     }
    ]
 * 2.在使用页面使用<InputItemList data={data} />
 * 3.inputType == 'text' or 'undefined' , 在onChang事件中不能用replace去掉空格
 * 正确的做法：
 *   handleChange = (value, id) => {
 *   this.stores.changeState(id, value);
 *  };
 */

const nowTimeStamp = Date.now();
const now = new Date(nowTimeStamp);

/**
 * @name
 * @params {array} data  表示这个需要循环的表单项的集合
 * @params {fn} onChange 表示表单发生改变时触发的事件
 * @params {object} bindData 表示表单的值的对象{id1:value1,id2:value2},id 和data里的id一一对应
 * @return:
 */
@inject('AppMod')
@observer
class InputItemList extends React.Component {
  constructor(props) {
    super(props);
    this.appStore = this.props.AppMod;
    this.state = {
      isShowPicker: false, // 区域选择面板
      isShowSelect: false, // select面板
      isShowDatePicker: false, // datePicker面板
      item: {}, // 地址需要使用里边的参数
      modifyId: '', // 当前修改的id值（主要用于会覆盖的弹窗）
      passwordFocus: false, // 密码输入框是否处于聚焦状态
      areaCode: this.props.areaCode || '86', // 当前选中的区号,用于默认值造中逻辑
      isShowInternational: false,
      currentCode: this.props.areaCode || '86' // 当前选中的区号,用于当前UI层展示
    };
    // this.pwdInput = null; // 密码输入框
    this.toggleDatePicker = this.toggleDatePicker.bind(this);
    this.togglePicker = this.togglePicker.bind(this);
    this.toggleSelect = this.toggleSelect.bind(this);
    this.autoFocusInst = null;
    this.itemJSon = null; // 保存当前JSON，主要用于国际区号切换
  }

  async componentDidMount() {
    this.autoFocusInst && this.autoFocusInst.focus();
    if (this.appStore.isInternationalized && !this.props.skipInternationalizationLogic) {
      // CodeConfirmView 和 页面表单 会走下面的逻辑 重复了 需要拦截下
      // 安全验证
      const item = Language_List.find((item) => item.value === localStorage.getItem('lng')) || {};
      const areaCode = this.appStore.getMatchedDefaultAreaCode(item);
      this.setState({
        areaCode: areaCode,
        currentCode: getDomainCodeByAreaCode(areaCode).code || areaCode
      });
      this.appStore.changeState('areaCode', areaCode);
    } else if (!this.props.areaCode) {
      const areaCode = this.appStore.userInfo.areaCode ? this.appStore.userInfo.areaCode : 86;
      this.setState({
        areaCode: areaCode,
        currentCode: getDomainCodeByAreaCode(areaCode).code || areaCode
      });
      this.appStore.changeState('areaCode', areaCode);
    }
  }

  handleArea = (arr) => {
    let str = '';
    arr &&
      arr.forEach((item, idx) => {
        // if (str !== item.label) {
        if (item.label) {
          str += item.label;
        }
        // }
      });

    return str;
  };

  togglePicker(id = '', item = {}) {
    this.setState((prevState) => ({
      isShowPicker: !prevState.isShowPicker,
      modifyId: id,
      item
    }));
  }

  toggleSelect(id = '', item = {}) {
    this.setState((prevState) => ({
      isShowSelect: !prevState.isShowSelect,
      modifyId: id,
      item
    }));
  }

  toggleDatePicker(id = '', item = {}) {
    this.setState((prevState) => ({
      isShowDatePicker: !prevState.isShowDatePicker,
      modifyId: id,
      item
    }));
  }

  /**
   * 普通输入框
   */
  renderInput(item, value) {
    const { onChange, onBlur, onFocus } = this.props;
    const {
      placeholder,
      maxLength,
      inputType,
      editable = true,
      isEncrypt,
      rightContent,
      id,
      styleobj,
      cleanSpace = false, // 是否清除字符串空格
      inputSercet = false,
      redSign, // 是否显示红点
      disabled = false,
      theTopLabel, // 是否显示顶部label
      hiddenLabel = false,
      topRedSign = false
    } = item;
    const { passwordFocus } = this.state;
    const nameValue = this.state;
    let inputValue = value ? value.toString() : '';
    if (isEncrypt && editable == false) {
      inputValue = Util.encryptStr(inputValue);
    }
    this.itemJSon = item.itemJson || null;

    if (id == 'realName') {
      item['data-security'] = true;
    }

    if (inputType == 'password') {
      setTimeout(() => {
        if (this[`pwdInput_${id}`]) {
          this[`pwdInput_${id}`].value = inputValue;
        }
      }, 0);
      return (
        <Flex direction={theTopLabel ? 'column' : 'row'}>
          {theTopLabel && (
            <Flex>
              {topRedSign && (
                <span className="fz-28 color-red" style={{ marginRight: 10 }}>
                  *
                </span>
              )}
              <Flex className="fz-28 color-gray top-label">{theTopLabel}</Flex>
            </Flex>
          )}
          <Flex justify="between" className="input-box">
            {redSign && (
              <span className="fz-28 color-red" style={{ marginRight: 10 }}>
                *
              </span>
            )}
            {!!item.label && (
              <span
                className={cx('fz-28', 'color-grey', 'label', { required: item.require })}
                style={{
                  ...(this.props.labelStype || {})
                }}>
                {item.label}
              </span>
            )}
            {!item.label && !item.hiddenLeft && <span style={{ 'margin-right': '0.1rem' }} />}
            <Flex.Item className="input-wrap">
              <input
                autoComplete="new-password"
                ref={(ref) => {
                  this[`pwdInput_${id}`] = ref;
                }}
                className="pwd-input"
                type="password"
                placeholder={placeholder}
                maxLength={maxLength || 999}
                editable={item.editable}
                style={{
                  ...(styleobj || {}),
                  textAlign: item.moneyKeyboardAlign || 'left',
                  ...(item.styleArea && item.styleArea.width
                    ? { paddingLeft: item.styleArea.width }
                    : { paddingLeft: (item.styleArea && item.styleArea.padding) || '48px' })
                }}
                onFocus={(event) => {
                  if (!editable) return;
                  const { value } = event.target;
                  this.setState({ passwordFocus: true });
                  // 防止键盘挡住
                  if (inputType === 'money') {
                    const height =
                      window.innerHeight ||
                      document.documentElement.clientHeight ||
                      document.body.clientHeight;
                    document.documentElement.style.height = `${height + 1000}px`;
                  }
                  (item.onFocus && item.onFocus(value)) || (onFocus && onFocus(value));
                }}
                onBlur={(event) => {
                  if (!editable) return;
                  let { value } = event.target;
                  setTimeout(() => {
                    if (this[`pwdInput_${id}`] != document.activeElement) {
                      this.setState({ passwordFocus: false });
                    }
                  }, 250);
                  if (inputType === 'money') {
                    document.documentElement.style.height = 'auto';
                  }
                  (item.onBlur && item.onBlur(value)) || (onBlur && onBlur(value));
                }}
                onChange={(e) => {
                  onChange(e.target.value, item.id, item.inputType);
                  item.onChange && item.onChange(e.target.value);
                }}
                onCut={() => false}
                onPaste={(e) => {
                  e.preventDefault();
                  return false;
                }}
              />
              {item.clear && passwordFocus ? (
                <i
                  className="iconfont icon-reeor"
                  onClick={() => {
                    this[`pwdInput_${id}`].value = '';
                    onChange('', item.id);
                    item.onChange && item.onChange('');
                  }}
                />
              ) : (
                ''
              )}
            </Flex.Item>

            {rightContent}
          </Flex>
        </Flex>
      );
    }
    return (
      <Flex
        style={{
          width: '100%',
          '--input-label': hiddenLabel ? '0px' : '',
          '--am-input-control': hiddenLabel ? '0px' : '24px',
          '--am-input-extra': hiddenLabel ? '0px' : '.4px'
        }}
        direction={theTopLabel ? 'column' : 'row'}>
        {theTopLabel && (
          <Flex>
            {topRedSign && (
              <span className="fz-28 color-red" style={{ marginRight: 10 }}>
                *
              </span>
            )}
            <Flex className="fz-28 color-gray top-label">{theTopLabel}</Flex>
          </Flex>
        )}
        <Flex>
          {redSign && (
            <span className="fz-28 color-red" style={{ marginRight: 10 }}>
              *
            </span>
          )}
          <InputItem
            {...item}
            autoComplete="off"
            type={inputType}
            value={inputValue}
            style={{
              ...styleobj,
              ...(item.styleArea && item.styleArea.width
                ? { paddingLeft: item.styleArea.width }
                : { paddingLeft: (item.styleArea && item.styleArea.padding) || '48px' })
            }}
            className={cx(item.isInternational ? 'have-area-code' : '')}
            placeholder={placeholder}
            maxLength={maxLength || 999}
            // clear
            onFocus={(value) => {
              if (!editable) return;
              if (cleanSpace) value = value.replace(/\s*/g, '');
              // 防止键盘挡住
              if (inputType === 'money') {
                const height =
                  window.innerHeight ||
                  document.documentElement.clientHeight ||
                  document.body.clientHeight;
                document.documentElement.style.height = `${height + 1000}px`;
              }
              (item.onFocus && item.onFocus(value)) ||
                (onFocus && onFocus(value.replace(/\s*/g, '')));
            }}
            onBlur={(value) => {
              if (!editable) return;
              if (cleanSpace) value = value.replace(/\s*/g, '');
              if (inputType === 'money') {
                document.documentElement.style.height = 'auto';
              }
              if (inputType === 'text' || inputType == undefined) {
                (item.onBlur && item.onBlur(value)) || (onBlur && onBlur(value));
                // 2025/09/10: 本次修改目的是在失焦时把value的内容trim，防止传给后台时参数首尾带空白符号，导致请求失败。
                // 但是因为有onChange在，会重新把原值赋值，导致trim动作失效，所以这里注释onChange。
                //
                // 调用onChange是在2020-06-30 Commit 7868d344引入，但原提交已经看不明白意思，尝试复现也未成功，故回退。
                // 原提交描述: 修复表单输入组件InputItemList， 在ios汉字输入情况，自动重复带出多余的字符串。在type为text情况下，无需处理去掉空格
                //
                // onChange(value, item.id);
                // item.onChange && item.onChange(value);
              } else {
                (item.onBlur && item.onBlur(value)) || (onBlur && onBlur(value));
              }
            }}
            disabled={disabled}
            editable={item.editable}
            moneyKeyboardAlign={item.moneyKeyboardAlign || 'left'}
            onChange={(value) => {
              if (!editable) return;
              console.log('value >> ', value, value.length, cleanSpace);
              if (cleanSpace) value = value.replace(/\s*/g, '');

              if (inputType == 'text' || inputType == undefined) {
                onChange(value, item.id);
                item.onChange && item.onChange(value);
              } else {
                onChange(value, item.id);
                item.onChange && item.onChange(value);
              }
            }}>
            <span className={cx({ required: item.require })}>{item.label}</span>
            {item.isInternational && (
              <div
                style={{ ...item.styleArea }}
                className="area-code-box"
                onClick={() => {
                  this.setState({
                    isShowInternational: true
                  });
                }}>
                + {this.state.currentCode}
                <img className="select-img" src="assets/imgs/common/select.png" />
                <div className="area-code-line"></div>
              </div>
            )}
            {item.isInternational && (
              <Picker
                visible={this.state.isShowInternational}
                data={item.itemJson || []}
                // 解决默认值/回显问题：通过唯一的 code2/value，绝对不会出现 US/CA 冲突
                value={[this.state.areaCode]}
                cols={1}
                showSearch={this.appStore.isInternationalized}
                searchPlaceholder={'请输入区号或地区名称搜索'}
                searchKey={['label', 'domainAbbreviation', 'value']}
                onChange={this.onChangeColor}
                onOk={() => {
                  this.setState({
                    isShowInternational: false
                  });
                }}
                onDismiss={() => {
                  this.setState({
                    isShowInternational: false
                  });
                }}>
                {/* <List.Item arrow="horizontal"></List.Item> */}
              </Picker>
            )}
          </InputItem>
        </Flex>
      </Flex>
    );
  }

  onChangeColor = (color) => {
    const val = color[0];

    // 反解出真实给后端的 code，比如 'US' 变成 '1'
    let realCode = val;
    const matchCountry = countryList.find(
      (i) => String(i.code2) === String(val) || String(i.code) === String(val)
    );
    if (matchCountry) {
      // 取出真实的区号
      realCode = matchCountry.code;
    }

    this.setState({
      areaCode: val, //
      currentCode: realCode // UI显示内容
    });
    // appStore 和对外抛出选中的区号
    this.appStore.changeState('areaCode', val);
    this.props.onAreaCodeChange && this.props.onAreaCodeChange(val);
  };

  renderArea(item, value) {
    const { editable = true, defaultValue, placeholder, id, label } = item;
    console.log('adadadadadasdad', toJS(value));
    const valueText = this.handleArea(value) || defaultValue;

    return (
      <Flex
        justify="between"
        className="area-box"
        onClick={() => {
          if (editable === undefined || editable) {
            this.togglePicker(id, item);
          }
        }}>
        <Flex>
          <span className={cx('fz-28', 'color-grey', 'label', { required: item.require })}>
            {label}
          </span>
          <span className={cx('fz-28 placeholder', { value: valueText })}>
            {valueText || placeholder}
          </span>
        </Flex>

        <span className="iconfont icon-arrow-right" />
      </Flex>
    );
  }

  /**
   * select输入框
   */
  renderSelect(item, value) {
    const { editable = true, placeholder, id, label, list, rightContent, getClickById } = item;
    let valueText = '';
    for (let i = 0; i < list.length; i++) {
      if (`${list[i].value}` == `${value}`) {
        valueText = list[i].label;
        break;
      }
    }
    return (
      <Flex
        justify="between"
        className="select-box"
        onClick={() => {
          if (editable === undefined || editable) {
            this.toggleSelect(id, item);
          } else {
            getClickById && getClickById();
          }
        }}>
        <Flex>
          <span className={cx('fz-28', 'color-grey', 'label', { required: item.require })}>
            {label}
          </span>
          <span className={cx('fz-28 placeholder', { value: valueText })}>
            {valueText || placeholder}
          </span>
        </Flex>

        {rightContent || (editable && <span className="iconfont icon-arrow-right" />)}
      </Flex>
    );
  }

  /**
   * DatePicker选择框
   */
  renderDatePicker(item, value) {
    const { editable = true, placeholder, defaultValue, id, label, rightContent } = item;
    let valueText = '';
    if (item.creditCard) {
      valueText = value || defaultValue;
    } else {
      if (defaultValue) {
        valueText = dayjs(defaultValue).format(item.format || 'YYYY-MM-DD');
      }
      if (value) {
        valueText = dayjs(value).format(item.format || 'YYYY-MM-DD');
      }
    }

    return (
      <Flex
        justify="between"
        className="date-box"
        onClick={() => {
          if (editable === undefined || editable) {
            this.toggleDatePicker(id, item);
          }
        }}>
        <Flex>
          <span className={cx('fz-28', 'color-grey', 'label', { required: item.require })}>
            {label}
          </span>
          <span
            className={cx(
              'fz-28 placeholder',
              { value: valueText },
              { colorLightGrey: !editable }
            )}>
            {valueText || placeholder}
          </span>
        </Flex>

        {rightContent || (editable && <span className="iconfont icon-arrow-right" />)}
      </Flex>
    );
  }

  /**
   * textarea多行输入框
   */
  renderTextarea(item, value) {
    const { onChange, onBlur, onFocus } = this.props;
    const {
      placeholder,
      maxLength,
      inputType,
      label,
      editable = true,
      autoHeight = false,
      rows = 1
    } = item;

    console.log('11111', item, value);

    return (
      <Flex justify="between" align="start" className="textarea-box">
        {/* <Flex align = 'start'> */}
        <span
          className={cx('fz-28', 'color-grey', 'label', 'am-input-label', {
            required: item.require
          })}>
          {label}
        </span>
        <TextareaItem
          {...item}
          className="fz-28"
          value={value === null || undefined === value ? '' : value.toString()}
          placeholder={placeholder}
          maxLength={maxLength || 9999}
          autoHeight={autoHeight}
          ref={(el) => (this.autoFocusInst = el)}
          onFocus={(value) => {
            if (!editable) return;
            // 防止键盘挡住
            if (inputType === 'money') {
              const height =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
              document.documentElement.style.height = `${height + 1000}px`;
            }
            (item.onFocus && item.onFocus(value)) || (onFocus && onFocus(value));
          }}
          onBlur={() => {
            if (!editable) return;
            if (inputType === 'money') {
              document.documentElement.style.height = 'auto';
            }
            (item.onBlur && item.onBlur(value)) || (onBlur && onBlur(value));
          }}
          editable={item.editable}
          onChange={(value) => {
            onChange(value, item.id);
            item.onChange && item.onChange(value);
          }}>
          {item.label}
        </TextareaItem>
        {/* </Flex> */}
      </Flex>
    );
  }

  /**
   * 多行显示
   */
  renderFullWord(item, value) {
    // const { onClick } = this.props;
    const { placeholder, id, label, getClick } = item;
    let valueText = value == null ? '' : value.toString();
    return (
      <Flex
        justify="between"
        className="full-box"
        onClick={() => {
          getClick && getClick();
        }}>
        <Flex align="start">
          <span
            className={cx('fz-28', 'color-grey', 'label', 'am-input-label', {
              required: item.require
            })}>
            {label}
          </span>
          <Flex.Item className={cx('fz-28 placeholder', { value: valueText })}>
            {valueText || placeholder}
          </Flex.Item>
        </Flex>
      </Flex>
    );
  }

  /**
   * skip，点击跳转或点击获取点击钩子
   */
  renderSkip(item, value) {
    const { onClick } = this.props;
    const { placeholder, id, label, url, noUrl, getClick, state } = item;
    let valueText = value == null ? '' : value.toString();
    return (
      <Flex
        justify="between"
        className="skip-box"
        onClick={() => {
          if (!noUrl) {
            url
              ? window.app.routerGoTo({
                  pathname: url,
                  state: state || {}
                })
              : console.warn(
                  'input类型为skip，请传入有效的url，若需求只为获取点击事件，请传入 noUrl: true'
                );
          } else {
            getClick && getClick();
          }
          onClick && onClick(id);
        }}>
        <Flex>
          <span
            className={cx('fz-28', 'color-grey', 'label', 'am-input-label', {
              required: item.require
            })}>
            {label}
          </span>
          <span className={cx('fz-28 placeholder', { value: valueText })}>
            {valueText || placeholder}
          </span>
        </Flex>

        <span className="iconfont icon-arrow-right" />
      </Flex>
    );
  }

  /**
   * radio，点击跳转或点击获取点击钩子
   */
  renderRadio(item, values) {
    const { id, label, list, onChange } = item;
    return (
      <Flex className="radio-box">
        <span
          className={cx('fz-28', 'color-grey', 'label', 'am-input-label', {
            required: item.require
          })}>
          <span>{label}</span>
        </span>
        <Flex align="center" style={{ flex: 1 }}>
          {list.map((radio) => (
            <div
              className="radio-item"
              onClick={() => {
                onChange && onChange(radio.value, !values.includes(radio.value));
              }}>
              <Radio checked={values.includes(radio.value)} />
              <span>{radio.label}</span>
            </div>
          ))}
        </Flex>
      </Flex>
    );
  }

  /**
   * certImage，证件图片上传（支持身份证正反面或普通多图上传）
   * 回显数据格式：['图片地址 1', '图片地址 2', ...]
   */
  renderCertImage(item, value) {
    const { onChange } = this.props;
    const { label, identityType = 0, editable = true, maxLength = 3, require, rightText } = item;
    const imageList = toJS(value) || [];

    // 身份证模式：显示正反面上传
    if (identityType === 1) {
      // 将字符串数组转换为 ImagePicker 需要的格式
      const frontImg = imageList && imageList[0] ? [imageList[0]] : [];
      const backImg = imageList && imageList[1] ? [imageList[1]] : [];
      // 使用 JSON.stringify 确保每次图片变化时 key 都不同，强制组件重新渲染
      const frontKey = JSON.stringify(frontImg);
      const backKey = JSON.stringify(backImg);

      return (
        <div className="cert-image-block">
          <div className="cert-header">
            <span className={cx('cert-label', { required: require })}>{label}</span>
            <span className="img-tips">请上传身份证正反面</span>
          </div>
          <div className="idcard-upload">
            <div className="upload-item">
              <ImagePicker
                isPrivate
                key={frontKey}
                editable={editable}
                icon={
                  <div className="icon">
                    <span className="iconfont icon-upload" />
                  </div>
                }
                style={{
                  background:
                    'url(' + Config.CDN_BASE + '/assets/imgs/common/idcard_front.png) no-repeat',
                  backgroundSize: '100% 100%'
                }}
                initialImgList={frontImg}
                onChange={(imgs) => {
                  let list = [].concat(imageList);
                  list[0] = imgs[0] ? imgs[0] : '';
                  console.log('imageList11', frontImg);
                  onChange(list, item.id);
                }}
              />
              <div className="upload-desc">
                <label>上传身份证正面</label>
                <p>（人像面）</p>
              </div>
            </div>
            <div className="upload-item">
              <ImagePicker
                isPrivate
                key={backKey}
                editable={editable}
                icon={
                  <div className="icon">
                    <span className="iconfont icon-upload" />
                  </div>
                }
                style={{
                  background:
                    'url(' + Config.CDN_BASE + '/assets/imgs/common/idcard_back.png) no-repeat',
                  backgroundSize: '100% 100%'
                }}
                initialImgList={backImg}
                onChange={(imgs) => {
                  let list = [].concat(imageList);
                  list[1] = imgs[0] ? imgs[0] : '';
                  onChange(list, item.id);
                }}
              />
              <div className="upload-desc">
                <label>上传身份证反面</label>
                <p>（国徽面）</p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // 普通多图上传模式
    // 将字符串数组转换为 ImagePicker 需要的格式
    const initialList = imageList || [];

    return (
      <div className="cert-image-block">
        <div className="cert-header">
          <span className={cx('cert-label', { required: require })}>{label}</span>
          <span className="img-tips">{!!rightText ? rightText : `最多上传${maxLength}张`}</span>
        </div>
        <ImagePicker
          isPrivate
          key={JSON.stringify(initialList)}
          title="点击上传"
          className="normal-img"
          maxLength={maxLength}
          initialImgList={initialList}
          onChange={(imgs) => {
            onChange(imgs, item.id);
          }}
        />
      </div>
    );
  }

  /**
   * file，点击选择上传文件
   */
  renderFile(item, value) {
    const { editable = true, placeholder, id, label, rightContent } = item;

    return (
      <FilePicker
        scene={this.props.scene || ''}
        editabled={editable}
        style={{ width: '100%' }}
        onChange={(res, name) => {
          // if (editable === undefined || editable) {
          //   this.toggleSelect(id, item);
          // }
        }}>
        <Flex
          justify="between"
          className="file-box"
          onClick={() => {
            // if (editable === undefined || editable) {
            //   this.toggleSelect(id, item);
            // }
          }}>
          <Flex style={{ width: '100%' }}>
            <span
              className={cx('fz-28', 'color-grey', 'label', 'am-input-label', {
                required: item.require
              })}>
              {label}
            </span>
            <Flex.Item className={cx('fz-28 placeholder', { value })}>
              {value || placeholder}
            </Flex.Item>
          </Flex>
          {rightContent || <span className="iconfont icon-arrow-right" />}
        </Flex>
      </FilePicker>
    );
  }

  render() {
    const { data, onChange, bindData = {}, onBlur, className, getClickId } = this.props;
    const { isShowPicker, isShowSelect, isShowDatePicker, item, modifyId } = this.state;
    const renderMethod = {
      area: 'renderArea',
      select: 'renderSelect',
      date: 'renderDatePicker',
      textarea: 'renderTextarea',
      skip: 'renderSkip',
      radio: 'renderRadio',
      file: 'renderFile',
      fullWord: 'renderFullWord',
      input: 'renderInput',
      certImage: 'renderCertImage'
    };
    return (
      <Flex direction="column" align="start" className={cx('custom-info-box', className)}>
        {data.map((item, idx) => {
          if (item.hide) return null;
          if (item.render) return item.render();
          const value = get(bindData, item.id, '');
          return item.hide ? null : (
            <Fragment>
              <Flex
                direction="column"
                align="start"
                justify="center"
                key={`custom_input_item_${idx}`}
                className={cx(
                  'input-item',
                  item.class,
                  item.inputDivClass,
                  {
                    'no-value':
                      (Array.isArray(toJS(value)) && !value.length) || (!value && value != 0)
                  },
                  { 'textarea-item': item.type == 'textarea' },
                  { 'full-word': item.type == 'fullWord' },
                  { 'cert-image-item': item.type == 'certImage' }
                )}>
                {item.type
                  ? this[renderMethod[item.type]](item, value)
                  : this.renderInput(item, value)}
                {/* {item.type === 'area'
                  ? this.renderArea(item, value)
                  : item.type === 'select'
                  ? this.renderSelect(item, value)
                  : item.type === 'date'
                  ? this.renderDatePicker(item, value)
                  : item.type === 'textarea'
                  ? this.renderTextarea(item, value)
                  : item.type === 'skip'
                  ? this.renderSkip(item, value)
                  : item.type === 'radio'
                  ? this.renderRadio(item, value)
                  : this.renderInput(item, value)} */}
                {item.absoluteChild && item.absoluteChild() && (
                  <div className={cx('input-item-child', this.props.inputItemBox || '')}>
                    {item.absoluteChild()}
                  </div>
                )}
                {item.type === 'fullWord' && item.extra && (
                  <div
                    style={{
                      position: 'absolute',
                      left: value.length <= 4 ? '40vw' : '45vw'
                    }}>
                    {item.extra}
                  </div>
                )}
                {item.type === 'textarea' && item.extra && (
                  <div
                    style={{
                      position: 'absolute',
                      right: 0
                    }}>
                    {item.extra}
                  </div>
                )}
              </Flex>
              {item.identityTypeExtra && item.identityTypeExtraContent}
              {item.id === 'syhe' && value && +value <= 3 && (
                <div
                  onClick={() => {
                    alert('', '您有一份全年复消套餐待查阅', [
                      { text: '取消', onPress: () => {} },
                      {
                        text: '去复消',
                        onPress: () =>
                          window.app.routerGoTo('/shop/home/special/1276230194428120102')
                      }
                    ]);
                  }}
                  style={{
                    display: 'inline-block',
                    width: '100%',
                    height: 'auto'
                  }}>
                  <img
                    src="https://image.yofogo.com/image/birthday.png"
                    alt=""
                    style={{ width: '100%', verticalAlign: 'top' }}
                    onLoad={() => {
                      // fire window resize event to change height
                      window.dispatchEvent(new Event('resize'));
                      // this.setState({ imgHeight: 'auto' });
                    }}
                  />
                </div>
              )}
            </Fragment>
          );
        })}

        {isShowPicker && (
          <AddressPicker
            disabledProvi={item.disabledProvi}
            visible={isShowPicker}
            value={toJS(bindData[modifyId])}
            cascade={item.cascade || 3}
            isWithDraw={item.isWithDraw || false}
            streetRequired={item.streetRequired || false}
            communityRequired={item.communityRequired || false}
            changeOnSelect={item.changeOnSelect || false}
            params={item.params}
            key={item.cascade}
            ok={(value, areaList) => {
              onChange(value, modifyId, areaList);
              getClickId && getClickId();
            }}
            onClose={this.togglePicker}
          />
        )}

        {isShowSelect && (
          <Picker
            visible={isShowSelect}
            value={bindData[modifyId] ? [bindData[modifyId]] : ''}
            data={item.list || []}
            title={item.title || ''}
            cols={item.cols || 1}
            onOk={(value) => {
              this.toggleSelect();
              onChange(value[0], modifyId);
            }}
            onDismiss={this.toggleSelect}
          />
        )}

        {isShowDatePicker && (
          <DatePicker
            {...item}
            visible={isShowDatePicker}
            value={new Date(bindData[modifyId] || '1990/01/01')}
            mode={item.mode || 'date'}
            onOk={(date) => {
              this.toggleDatePicker();
              let selDate = dayjs(date).format(item.format || 'YYYY-MM-DD');
              if (item.creditCard) {
                let year = selDate.split('-')[0].toString();
                let month = selDate.split('-')[1];
                selDate = `${year.slice(year.length - 2)}/${month}`;
              }
              onChange(selDate, modifyId);
            }}
            onDismiss={this.toggleDatePicker}
          />
        )}
      </Flex>
    );
  }
}

export default InputItemList;



// WEBPACK FOOTER //
// ./src/pubBiz/InputItemList/index.js